console.log(process.env.REACT_APP_API_ENDPOINT)

console.log("=====================================================")
let credentials = {
  API_URL: "http://localhost/api",
  PROMOTIONAL_API_URL: "http://localhost/api/promotional/",
  PRODUCT_URL: "http://localhost/products",
  PRODUCT_DETAILS_URL: "http://localhost/api/products"
};

if(process.env.REACT_APP_API_ENDPOINT==="staging"){
  credentials = {
  API_URL: "http://35.178.143.248/api",
  PROMOTIONAL_API_URL: "http://35.178.143.248/api/promotional/",
  PRODUCT_URL: "http://35.178.143.248/products",
  PRODUCT_DETAILS_URL: "http://35.178.143.248/api/products"
  }
}

if(process.env.REACT_APP_API_ENDPOINT==="development"){
  credentials = {
  API_URL: "http://localhost:8055/api",
  PROMOTIONAL_API_URL: "http://localhost:8055/api/promotional/",
  PRODUCT_URL: "http://localhost:8055/products",
  PRODUCT_DETAILS_URL: "http://localhost:8055/api/products"
  }
}

if(process.env.REACT_APP_API_ENDPOINT==="prod"){
  credentials = {
  API_URL: "https://seetutors.co.uk/api",
  PROMOTIONAL_API_URL: "https://seetutors.co.uk/api/promotional/",
  PRODUCT_URL: "https://seetutors.co.uk/products",
  PRODUCT_DETAILS_URL: "https://seetutors.co.uk/api/products"
  }
}

export default credentials;
